import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=04e39710&scoped=true&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&lang=less&"
import style1 from "./wallet.vue?vue&type=style&index=1&id=04e39710&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e39710",
  null
  
)

export default component.exports